$(document).ready(function () {
    partnerSlides();
    certificateSlides();
    handlePlayVideo();
    handleProcess();
});

function partnerSlides() {
    $('.partner').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        infinite: false,
        dots: false,
        arrow: false,
        prevArrow: "<button class='btn-prev-partner-slides btn-partner-slides'><img src='/assets/svg/icon/arrow-left-only.svg' alt=''></button>",
        nextArrow: "<button class='btn-next-partner-slides btn-partner-slides'><img src='/assets/svg/icon/arrow-right-only.svg' alt=''></button>",
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.5,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            },
        ],
    });

    $('.partner').on('afterChange', function (event, slick, currentSlide) {
        if ($(window).width() <= 992) {
            var $slider = $('.partner');
            var slickObj = $slider.slick('getSlick');

            // Total number of slides
            var totalSlides = slickObj.slideCount;

            // Number of slides currently displayed
            var totalItemDisplay = slickObj.options.slidesToShow;

            if (currentSlide + totalItemDisplay == totalSlides) {
                $('.btn-prev-partner-slides').removeClass('d-none');
                $('.btn-next-partner-slides').addClass('d-none');
            } else if (currentSlide + totalItemDisplay < totalSlides &&
                currentSlide > 0
            ) {
                $('.btn-prev-partner-slides').removeClass('d-none');
                $('.btn-next-partner-slides').removeClass('d-none');
            }

            if (currentSlide > 0) {
                $('.btn-prev-partner-slides').removeClass('d-none');
            } else if (currentSlide == 0) {
                $('.btn-prev-partner-slides').addClass('d-none');
                $('.btn-next-partner-slides').removeClass('d-none');
            }
        } else {
            $('.btn-prev-partner-slides').addClass('d-none');
            $('.btn-next-partner-slides').addClass('d-none');
        }
    });

    if ($(window).width() > 992) {
        $('.btn-prev-partner-slides').addClass('d-none');
        $('.btn-next-partner-slides').addClass('d-none');
    }
}

function handleProcess() {
    handleSuccessProject();
}

function handleSuccessProject() {
    const counter = document.getElementById('number-1');
    const number1 = $('#number-1');
    const number2 = $('#number-2');
    const number3 = $('#number-3');
    let hasScrolled = false;

    const updateNumber1 = () => {
        const target = 80;
        const interval = 5; // thời gian giữa mỗi bước (ms)
        const increment = target / (2000 / interval); // số bước để đạt được giá trị mục tiêu

        let current = 0;
        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                current = target;
                clearInterval(timer);
            }
            number1.text(Math.floor(current).toLocaleString() + '%');
        }, interval);
    };
    const updateNumber2 = () => {
        const target = 90;
        const interval = 5; // thời gian giữa mỗi bước (ms)
        const increment = target / (2000 / interval); // số bước để đạt được giá trị mục tiêu

        let current = 0;
        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                current = target;
                clearInterval(timer);
            }
            number2.text(Math.floor(current).toLocaleString() + '%');
        }, interval);
    };
    const updateNumber3 = () => {
        const target = 85;
        const interval = 5; // thời gian giữa mỗi bước (ms)
        const increment = target / (2000 / interval); // số bước để đạt được giá trị mục tiêu

        let current = 0;
        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                current = target;
                clearInterval(timer);
            }
            number3.text(Math.floor(current).toLocaleString() + '%');
        }, interval);
    };


    window.addEventListener('scroll', () => {
        const rect = counter.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

        if (!hasScrolled && rect.top <= windowHeight) {
            hasScrolled = true;

            updateNumber1();
            updateNumber2();
            updateNumber3();

            $('.list-process .list-process__item').addClass('--active');
        }
    });
}

function handlePlayVideo() {
    $('.layer').on('click', function () {
        console.log(123);

        const video = $('#video')[0];

        if (video.paused) {
            video.play();
            $('.layer').addClass('d-none');
        }
    })

    $('#video').on('click', function () {
        video.pause();
        $('.layer').removeClass('d-none');
    })

    $('.icon-play-video').hover(
        function () {
            console.log('in hover');

            $('.play-video-box').addClass('--active');
        },
        function () {
            console.log('leave hover');

            $('.play-video-box').removeClass('--active');
        }
    );
}

function certificateSlides() {
    $('.certificate-slides').slick({
        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: false,
        infinite: false,
        dots: false,
        arrow: true,
        prevArrow: "<button class='btn-prev-certificate-slides btn-certificate-slides d-none'><img src='/assets/svg/icon/arrow-left-only.svg' alt=''></button>",
        nextArrow: "<button class='btn-next-certificate-slides btn-certificate-slides'><img src='/assets/svg/icon/arrow-right-only.svg' alt=''></button>",

        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.8,
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1.5,
                }
            },
        ],
    });

    $('.certificate-slides').on('afterChange', function (event, slick, currentSlide) {
        if ($(window).width() >= 992) {
            var $slider = $('.certificate-slides');
            var slickObj = $slider.slick('getSlick');

            // Total number of slides
            var totalSlides = slickObj.slideCount;

            // Number of slides currently displayed
            var totalItemDisplay = slickObj.options.slidesToShow;

            if (currentSlide + totalItemDisplay == totalSlides) {
                $('.btn-prev-certificate-slides').removeClass('d-none');
                $('.btn-next-certificate-slides').addClass('d-none');
            } else if (currentSlide + totalItemDisplay < totalSlides &&
                currentSlide > 0
            ) {
                $('.btn-prev-certificate-slides').removeClass('d-none');
                $('.btn-next-certificate-slides').removeClass('d-none');
            }

            if (currentSlide > 0) {
                $('.btn-prev-certificate-slides').removeClass('d-none');
            } else if (currentSlide == 0) {
                $('.btn-prev-certificate-slides').addClass('d-none');
                $('.btn-next-certificate-slides').removeClass('d-none');
            }
        } else {
            $('.btn-prev-certificate-slides').addClass('d-none');
            $('.btn-next-certificate-slides').addClass('d-none');
        }
    });
}
